module.exports = "/virtual-football-league/img/amblems/right/logos/RealMadrid.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/RealMadrid.png
// module id = 2225
// module chunks = 4